import Icon from './../Icon'
import React from 'react'

export const Full = ({ children }) => (
  <div className="w-full h-full flex items-center justify-center text-xl text-gray-600">
    { children || (
      <div className="flex items-center space-x-1">
        <span className="font-medium">Loading..</span>
        <Icon icon={['fal', 'spinner-third']} className="animate-spin" />
      </div>
    ) }
  </div>
)

export const Flex = ({ children }) => (
  <div className="grow flex justify-center items-center text-xl text-gray-600">
    { children || (
      <div className="flex items-center space-x-1">
        <span className="font-medium">Loading..</span>
        <Icon icon={['fal', 'spinner-third']} className="animate-spin" />
      </div>
    ) }
  </div>
)

export default Full
